import { IconName } from '../icons/Icon';

export interface NavItem {
  label: string;
  icon: IconName;
  path: string;
}

export type PrimaryNavContext = {
  cohorts?: {
    id: string;
    name: string;
    is_active: boolean;
    role: 'mentee' | 'mentor' | 'cohort_director' | 'cohort_admin';
  }[];
};

const defaultNavItems: NavItem[] = [
  { label: 'Home', icon: "House", path: '/home' },
  { label: 'Courses', icon: "BookOpen", path: '/training' },
  { label: 'Snapshot', icon: "ChartNoAxesColumn", path: '/snapshot' },
  { label: 'Notes', icon: "NotebookPen", path: '/toolkit' },
];

const mentorshipNavItems = (): NavItem[] => {
  return [
    { label: 'Home', icon: 'House', path: '/home' },
    { label: 'Courses', icon: 'BookOpen', path: '/training' },
    { label: 'Cohort', icon: 'UsersRound', path: '/mentorship' },
    { label: 'Snapshot', icon: 'ChartNoAxesColumn', path: '/snapshot' },
    { label: 'Notes', icon: 'NotebookPen', path: '/toolkit' },
  ];
};

export const getPrimaryNavItems = (context?: PrimaryNavContext): NavItem[] => {
  const cohorts = context?.cohorts ?? [];
  const activeRoles = cohorts.filter((c) => c.is_active).map((c) => c.role);
  const isCohortUser = activeRoles.length > 0;
  const mentorshipEligible = activeRoles.some((role) =>
    role === 'mentor' ||
    role === 'mentee' ||
    role === 'cohort_director' ||
    role === 'cohort_admin'
  );

  return isCohortUser && mentorshipEligible ? mentorshipNavItems() : defaultNavItems;
};

export const primaryNavItems: NavItem[] = defaultNavItems;
